import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const Channel = Loadable(lazy(() => import('views/Channel')));
const ModelConfig = Loadable(lazy(() => import('views/ModelConfig')));
const Log = Loadable(lazy(() => import('views/Log')));
const LogFeedback = Loadable(lazy(() => import('views/LogFeedback')));
const Redemption = Loadable(lazy(() => import('views/Redemption')));
const Order = Loadable(lazy(() => import('views/Order')));
const Setting = Loadable(lazy(() => import('views/Setting')));
const Token = Loadable(lazy(() => import('views/Token')));
const Topup = Loadable(lazy(() => import('views/Topup')));
const User = Loadable(lazy(() => import('views/User')));
const Profile = Loadable(lazy(() => import('views/Profile')));
const NotFoundView = Loadable(lazy(() => import('views/Error')));
const VersionRelease = Loadable(lazy(() => import('views/VersionRelease')));
const RespalDashboard = Loadable(lazy(() => import('views/RespalDashboard')));
const AdminOperationLog = Loadable(lazy(() => import('views/AdminOperationLog')));
const ProductManagement = Loadable(lazy(() => import('views/ProductManagement')));
const AdminPermissions = Loadable(lazy(() => import('views/AdminPermissions')));
const InfluencerCode = Loadable(lazy(() => import('views/InfluencerCode')));
const Activity = Loadable(lazy(() => import('views/Activity')));
const UserCrowd = Loadable(lazy(() => import('views/UserCrowd')));
const Notification = Loadable(lazy(() => import('views/Notification')));
const Skill = Loadable(lazy(() => import('views/Skill')));
const SkillCategory = Loadable(lazy(() => import('views/SkillCategory')));

// dashboard routing
const Dashboard = Loadable(lazy(() => import('views/Dashboard')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/panel',
  element: <MainLayout />,
  children: [
    {
      path: '',
      element: <Dashboard />
    },
    {
      path: 'dashboard',
      element: <Dashboard />
    },
    {
      path: 'channel',
      element: <Channel />
    },
    {
      path: 'model-config',
      element: <ModelConfig />
    },
    {
      path: 'log',
      element: <Log />
    },
    {
      path: 'log-feedback',
      element: <LogFeedback />
    },
    {
      path: 'redemption',
      element: <Redemption />
    },
    {
      path: 'order',
      element: <Order />
    },
    {
      path: 'setting',
      element: <Setting />
    },
    {
      path: 'token',
      element: <Token />
    },
    {
      path: 'topup',
      element: <Topup />
    },
    {
      path: 'user',
      element: <User />
    },
    {
      path: 'profile',
      element: <Profile />
    },
    {
      path: '404',
      element: <NotFoundView />
    },
    {
      path: 'version-release',
      element: <VersionRelease />
    },
    {
      path: 'respal-dashboard',
      element: <RespalDashboard />
    },
    {
      path: 'admin-operation-log',
      element: <AdminOperationLog />
    },
    {
      path: 'product-management',
      element: <ProductManagement />
    },
    {
      path: 'admin-permissions',
      element: <AdminPermissions />
    },
    {
      path: 'influencer-code',
      element: <InfluencerCode />
    },
    {
      path: 'activity',
      element: <Activity />
    },
    {
      path: 'user-crowd',
      element: <UserCrowd />
    },
    {
      path: 'notification',
      element: <Notification />
    },
    {
      path: 'skill',
      element: <Skill />
    },
    {
      path: 'skill/categories',
      element: <Skill />
    }
  ]
};

export default MainRoutes;
